const medWhrsMngt = {
    namespaced: true,
    state : {
        medWhrsCd : '',
        medicineNm : '',
        chkInfo : '',
        startDt : '',
        endDt : '',
        status : ''
    },
    getters: {
        getMedWhrsCd (state) {
            return state.medWhrsCd
        },
        getMedicineNm (state) {
            return state.medicineNm
        },
        getChkInfo (state) {
            return state.chkInfo
        },
        getStartDt (state) {
            return state.startDt
        },
        getEndDt (state) {
            return state.endDt
        },
        getStatus (state) {
            return state.status
        },
    },
    mutations: {
        setMedWhrsCd (state, payload) {
            state.medWhrsCd = payload
        },
        setMedicineNm (state, payload) {
            state.medicineNm = payload
        },
        setChkInfo (state, payload) {
            state.chkInfo = payload
        },
        setStartDt (state, payload) {
            state.startDt = payload
        },
        setEndDt (state, payload) {
            state.endDt = payload
        },
        setStatus (state, payload) {
            state.status = payload
        },

    },
    actions: {
        setMedWhrsCd ({commit}, payload) {
            commit('setMedWhrsCd', payload)
        },
        setMedicineNm ({commit}, payload) {
            commit('setMedicineNm', payload)
        },
        setChkInfo ({commit}, payload) {
            commit('setChkInfo', payload)
        },
        setStartDt ({commit}, payload) {
            commit('setStartDt', payload)
        },
        setEndDt ({commit}, payload) {
            commit('setEndDt', payload)
        },
        setStatus ({commit}, payload) {
            commit('setStatus', payload)
        },
        setMedicineMngtinit ({commit}) {
            commit('setMedWhrsCd','');
            commit('setMedicineNm','');
            commit('setStartDt','');
            commit('setEndDt','');
            commit('setChkInfo','');
            commit('setStatus','');
        },
    }
}


export default medWhrsMngt